import { affiliateService } from "@features/affiliate/AffiliateService";
import { AffiliateOutputDTO } from '@features/affiliate/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: AffiliateReducer,
  actions: AffiliateActions,
  fetchAll: fetchAffiliates,
  fetchById: fetchAffiliateById,
  createEntity: createAffiliate,
  updateEntity: updateAffiliate,
  deleteEntity: deleteAffiliate,
} = createEntitySlice<AffiliateOutputDTO>("Affiliate", affiliateService);

export {
  AffiliateReducer,
  AffiliateActions,
  fetchAffiliates,
  fetchAffiliateById,
  createAffiliate,
  updateAffiliate,
  deleteAffiliate,
};